import request from '@/util/request'


export const resourcesApplyList = (data) => request.post('/api/resourcesApplyList', data);//提交的任务列表

export const resourcesUnmannedApplyList = (data) => request.post('/api/resourcesUnmannedApplyList', data);//未认领的任务列表